import { StandardColumn } from '../../../../components/StandardPage'

export const certificatesScreenKey = 'certificates'

export interface CertificateRow {
  id: number
  param: string
  supplier: string
  customer: string
  heatNumber: string
  type: { id: number; name: string }
  supplierIsMain: boolean
  date: string
  codeOpString: string
}

const resolveTypeLabel = (row: CertificateRow): string => {
  if (row.type.id === 1 && row.supplierIsMain) return 'Qualidade'
  if (row.type.id === 1) return 'Origem'
  return row.type.name
}

export const buildCertificatesColumns = (): StandardColumn<CertificateRow>[] => [
  {
    id: 'param',
    label: 'Parâmetro',
  },
  {
    id: 'supplier',
    label: 'Fornecedor',
  },
  {
    id: 'customer',
    label: 'Cliente',
  },
  {
    id: 'type',
    label: 'Tipo do certificado',
    accessor: (row) => resolveTypeLabel(row),
  },
  {
    id: 'heatNumber',
    label: 'Nº da corrida',
  },
  {
    id: 'date',
    label: 'Data de criação',
  },
  {
    id: 'codeOpString',
    label: 'OP',
  },
]
